'use client';
import ExpiredPage from '@/components/page/expired-page';
import MaintenancePage from '@/components/page/maintenance-page';
import UnavailablePage from '@/components/page/unavailable-page';
import { redirect, useSearchParams } from 'next/navigation';

export default function BusinessVerificationWrapper({
    children,
    businessData,
    businessStatus,
    maMode,
}: {
    children: React.ReactNode;
    businessData: {
        isExpired: boolean;
        activeDomain: string;
        domain: string;
    };
    businessStatus: {
        isDeleted: boolean;
        markedForDeletion: boolean;
        isActive: boolean;
    };
    maMode: boolean;
}) {
    const searchParams = useSearchParams();
    const currentPath = `${
        searchParams.toString() ? '?' + searchParams.toString() : ''
    }`;
    const { isExpired, activeDomain, domain } = businessData;

    // Verify maintenance mode
    if (maMode) {
        return <MaintenancePage />;
    }

    // Verify business status
    if (
        businessStatus.isDeleted ||
        businessStatus.markedForDeletion ||
        !businessStatus.isActive
    ) {
        return <UnavailablePage />;
    }

    // Verify business expiration (grace period applied on the server)
    if (isExpired) {
        return <ExpiredPage />;
    }

    // Verify business domain
    if (domain && domain !== activeDomain) {
        redirect(`https://${activeDomain}${currentPath}`);
    }

    return <>{children}</>;
}
